import { DEFAULT_USER, INTEGRATION_DOCUMENT } from '~/consts/psf';
import type { SellerInformation } from '~/domain/PSF';
import type { GetSellersResponseDTO } from '~/dto/PSF';
import { sellerInfoDTOToSellerInfo } from '~/mappers/PSF';
import apiPSFAnon from '~/services/apiPSFAnon';
import { getRawDocument } from '~/utils/string';

export async function getSellerInformationUseCase(
  document: string
): Promise<SellerInformation | false> {
  try {
    const response = await apiPSFAnon.post<GetSellersResponseDTO>(
      '/client/api/funcionario/search',
      {
        loginUsuario: DEFAULT_USER,
        cpfUsuario: INTEGRATION_DOCUMENT,
        service: 'funcionario',
        functionality: 'search',
        filial: 1033,
        idProcesso: '2020202020',
        idServico: '4940404940',
        ipUsuario: '10.10.10.10',
        origem: 'SITE',
        fluxo: 'OFERTA_SEGUROS',
        search: {
          tipo: 'CPF',
          value: `${getRawDocument(document)}`,
        },
      }
    );

    return sellerInfoDTOToSellerInfo(response.data, document);
  } catch (err) {
    return false;
  }
}
